import { toggleStateField } from '../../components/state'

function initPreApplicationForm() {
  const onChangeSelectElements =
    document.querySelectorAll<HTMLSelectElement>('select[ajax_url]')
  if (onChangeSelectElements.length === 0) {
    return
  }
  onChangeSelectElements.forEach((onChangeSelectElement) => {
    const labelId = onChangeSelectElement.id
    toggleStateField(onChangeSelectElement, labelId)
    onChangeSelectElement.addEventListener('change', function () {
      toggleStateField(onChangeSelectElement, labelId)
    })
  })
}

export { initPreApplicationForm }
